import Vue from "vue"
import Vuex from "vuex"

//asterisk below says:
//import all publications from user.js file into
//user namespace
import * as user from "@/store/modules/user.js"
import * as event from "@/store/modules/event.js"
import * as notification from "@/store/modules/notification.js"
import * as n_user from "@/store/modules/n_user.js"
import * as client from "@/store/modules/client.js"
import * as department from "@/store/modules/department.js"
import * as saveOp from "@/store/modules/saveOp.js"
import * as listOp from "@/store/modules/listOp.js"
import * as order from "@/store/modules/order.js"
import * as mcap from "@/store/modules/mcap.js"
import * as shipping from "@/store/modules/shipping.js"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    event,
    notification,
    n_user,
    client,
    department,
    saveOp,
    listOp,
    order,
    mcap,
    shipping
  },
  state: {
    count: 0,
    categories: [
      "sustainability",
      "nature",
      "animal welfare",
      "housing",
      "education",
      "food",
      "community"
    ],
    todos: [
      { id: 1, text: "...", done: true },
      { id: 2, text: "...", done: false },
      { id: 3, text: "...", done: true },
      { id: 4, text: "...", done: false }
    ]
  },
  mutations: {
    INCREMENT_COUNT(state, value) {
      state.count += value
    }
  },
  created() {},
  actions: {
    updateCount({ state, commit }, value) {
      /*using object destructuring to 
      take out just the state and commit from 
      store's Context Object       
      */
      if (state.user) {
        commit("INCREMENT_COUNT", value)
      }
    }
  },
  getters: {
    catLength: state => {
      return state.categories.length
    },
    doneToDos: state => {
      return state.todos.filter(todo => todo.done)
    },
    ToDoCount: (state, getters) => {
      return getters.doneToDos.length
    },
    MyString: () => {
      return "test"
    },
    getTodoById: state => id => {
      return state.todos.find(todo => todo.id === id)
    },
    getCount: state => {
      return state.count
    }
  }
})
